import { Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TDailyProcessingBatchDataTableData = {
  primaryKey: string | number,
  batchId: string,
  name: string,
  ref: string,
  date: string,
  start: string,
  end: string,
  status: string,
};
 

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TDailyProcessingBatchDataTableData>();

export function getDailyProcessingBatchDataTableColumns({ isLoading }: Props) {
  return [
    columnHelper.accessor('batchId', {
      id: 'batchId',
      header: 'Id Batch',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('name', {
      id: 'name',
      header: 'Nom',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    columnHelper.accessor('ref', {
      id: 'ref',
      header: 'Réf.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    columnHelper.accessor('date', {
      id: 'date',
      header: 'Date',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    columnHelper.accessor('start', {
      id: 'start',
      header: 'Début',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    columnHelper.accessor('end', {
      id: 'end',
      header: 'Fin',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    columnHelper.accessor('status', {
      id: 'status',
      header: 'Statut',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
  ];
}